import * as Yup from 'yup';
import { t } from 'src/lib/language';

const OrganisationEmailsValidator = (lang: string) => Yup.object().shape({
  receipt_email_title: Yup.string().nullable(),
  receipt_email_message: Yup.string().nullable(),
  invoice_email_title: Yup.string().nullable(),
  invoice_email_message: Yup.string().nullable(),
})
  .test(
    'receipt-email-pair',
    t(lang, 'validations.organisation.email_title_required'),
    function checkReceiptEmailPair(values) {
      const title = (values.receipt_email_title || '').trim();
      const message = (values.receipt_email_message || '').trim();

      if (title && !message) {
        return this.createError({
          path: 'receipt_email_message',
          message: t(lang, 'validations.organisation.email_message_required'),
        });
      }
      if (message && !title) {
        return this.createError({
          path: 'receipt_email_title',
          message: t(lang, 'validations.organisation.email_title_required'),
        });
      }
      return true;
    },
  )
  .test(
    'invoice-email-pair',
    t(lang, 'validations.organisation.email_title_required'),
    function checkInvoiceEmailPair(values) {
      const title = (values.invoice_email_title || '').trim();
      const message = (values.invoice_email_message || '').trim();

      if (title && !message) {
        return this.createError({
          path: 'invoice_email_message',
          message: t(lang, 'validations.organisation.email_message_required'),
        });
      }
      if (message && !title) {
        return this.createError({
          path: 'invoice_email_title',
          message: t(lang, 'validations.organisation.email_title_required'),
        });
      }
      return true;
    },
  );

export default OrganisationEmailsValidator;
